import React, { useEffect, useRef, useState } from "react";
import { api, mediaUrl } from "@/lib/api";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Plus, Trash2, Upload, Loader2 } from "lucide-react";

export default function AdminClients() {
  const [clients, setClients] = useState([]);
  const refs = useRef({});
  const [busy, setBusy] = useState(null);
  const load = () => api.get("/clients").then((r) => setClients(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const add = async () => { await api.post("/admin/clients", { name: "New brand", order: clients.length }); load(); };
  const save = async (c, fields) => { await api.put(`/admin/clients/${c.id}`, fields); load(); };
  const del = async (c) => { if (window.confirm(`Remove ${c.name}?`)) { await api.delete(`/admin/clients/${c.id}`); load(); } };

  const uploadLogo = async (c, e) => {
    const file = e.target.files?.[0]; if (!file) return;
    setBusy(c.id);
    const fd = new FormData(); fd.append("file", file); fd.append("kind", "logos");
    try {
      const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      await api.put(`/admin/clients/${c.id}`, { logo_url: data.url });
      toast.success("Logo uploaded"); load();
    } catch (err) { toast.error("Upload failed"); } finally { setBusy(null); e.target.value = ""; }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <div><h1 className="font-heading text-2xl font-bold">Trusted brands</h1><p className="mt-1 text-sm text-zinc-500">Logos shown on the homepage "Trusted by brands worldwide" section.</p></div>
        <button onClick={add} data-testid="add-client-btn" className="inline-flex items-center gap-2 rounded-full bg-brand-violet px-5 py-2.5 text-sm font-bold text-white hover:bg-brand-violetHover"><Plus size={16} /> Add brand</button>
      </div>
      <div className="mt-5 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {clients.map((c) => (
          <div key={c.id} data-testid={`admin-client-${c.id}`} className="rounded-xl border border-zinc-200 bg-white p-4">
            <div className="flex h-20 items-center justify-center rounded-lg bg-zinc-50">
              {c.logo_url ? <img src={mediaUrl(c.logo_url)} alt={c.name} className="max-h-16 max-w-full object-contain" /> : <span className="text-sm text-zinc-400">No logo</span>}
            </div>
            <Input defaultValue={c.name} onBlur={(e) => save(c, { name: e.target.value })} className="mt-3 h-9 rounded-lg" />
            <div className="mt-2 flex items-center gap-2">
              <input ref={(el) => (refs.current[c.id] = el)} type="file" accept="image/*" hidden onChange={(e) => uploadLogo(c, e)} data-testid={`client-logo-input-${c.id}`} />
              <button onClick={() => refs.current[c.id]?.click()} disabled={busy === c.id} className="inline-flex flex-1 items-center justify-center gap-1.5 rounded-lg border border-zinc-300 py-2 text-xs font-semibold hover:border-brand-violet">
                {busy === c.id ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />} Upload logo
              </button>
              <button onClick={() => del(c)} className="flex h-8 w-8 items-center justify-center rounded-lg text-zinc-400 hover:bg-red-50 hover:text-red-600"><Trash2 size={15} /></button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
